export default __webpack_public_path__ + "static/support-d1d8e0af83d4a9408d77e6e6c865df91.png";